import { Button, Form } from "antd";
import "../ep.scss";
import { useTranslation } from "react-i18next";
import ReactInputMask from "react-input-mask";
import { regexFormater, validateInput } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loading from "../../../auxiliary/loader/loading";
import Packages from "./packages";
import { switchPlanID } from "../../../../tools/services";
import { useLocation, useNavigate } from "react-router-dom";
import { _adr } from "../../../../address";
import ShopPage, { ShopSummary, toman } from "../../../auxiliary/shop/ShopPage";
import { useTaxPercent } from "../../../auxiliary/shop/WalletPrefactor";
import { EP_STEPS, packageMath } from "../prefactor/epPrefactor";

// packages -> group dropdowns: each group (ordered) with its sub-groups (ordered), plus the packages without duplicates
export const groupPackages = (response) => {
	const groups = new Map();
	const subgroups = new Map();
	response.forEach((p) => {
		if (!groups.has(p.productGroupId)) groups.set(p.productGroupId, p);
		if (!subgroups.has(p.productSubGroupId)) subgroups.set(p.productSubGroupId, p);
	});
	const sortedSubgroups = [...subgroups.values()].sort((a, b) => a.productSubOrderId - b.productSubOrderId);
	const categories = [...groups.values()]
		.sort((a, b) => a.productGroupOrderId - b.productGroupOrderId)
		.map((g) => ({
			productGroupId: g.productGroupId,
			productGroupName: g.productGroupName,
			subgroup: sortedSubgroups
				.filter((s) => s.productGroupId === g.productGroupId)
				.map((s) => ({
					inT_ProductSubGroupId: s.productSubGroupId,
					stR_ProductSubGroupName: s.productSubGroupName,
				})),
		}));
	const seen = new Set();
	const packages = response.filter((p) => !seen.has(p.packageId) && seen.add(p.packageId));
	return { categories, packages };
};

const EPValid = () => {
	const [t] = useTranslation("global");
	const [frmNumber] = Form.useForm();
	const { queryPackage } = useDealer();
	const location = useLocation();
	const nav = useNavigate();
	const user = useSelector((state) => state?.another?._currentUser);
	const tax = useTaxPercent();

	// purchase: subscriber chosen in 360 / corporate search (then packages load straight away)
	const [pack, setPack] = useState({
		isPackages: false,
		isLoading: false,
		cagegoryList: [],
		packageList: [],
		msisdn: "",
		purchase: location?.state || null,
	});
	const [selected, setSelected] = useState(null);

	useEffect(() => {
		if (pack?.purchase?.inT_MSISDN) prossesPackages();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const prossesPackages = async (values = null) => {
		setPack((pc) => ({ ...pc, isLoading: true }));
		setSelected(null);
		const payload = {
			msisdn: pack?.purchase?.inT_MSISDN || regexFormater(values?.msisdn).removeSpace(),
			planid: switchPlanID().extraPackage,
		};
		const response = await queryPackage(payload);
		if (response) {
			const { categories, packages } = groupPackages(response);
			setPack((pc) => ({
				...pc,
				isPackages: true,
				msisdn: payload.msisdn,
				packageList: packages,
				cagegoryList: categories,
			}));
		} else {
			setPack((pc) => ({ ...pc, isPackages: false }));
		}
		setPack((pc) => ({ ...pc, isLoading: false }));
	};

	const goPrefactor = () =>
		nav(_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.PreFactor, {
			state: {
				package: selected,
				msisdn: pack.msisdn,
				purchase: pack.purchase || null,
			},
		});

	// live summary: same maths as the pre-invoice
	const { total, commission, walletDebit } = packageMath(selected?.packagePrice, tax, user?.cpcommission);

	return (
		<>
			<ShopPage title={t("extraPackage.title")} prefix="ep" steps={EP_STEPS} step={0} purchase={pack.purchase}>
				<div className="charge-layout">
					{!pack?.purchase && (
						<section className="shop-section">
							<h4>
								<span className="num">۱</span>شماره موبایل مشترک
							</h4>
							<Form form={frmNumber} className="number-row" onFinish={(values) => prossesPackages(values)}>
								<Form.Item className="input-normal" name="msisdn" rules={[validateInput({ t: t, validate: true, type: "msisdnOrg" })]}>
									<div>
										<ReactInputMask dir="ltr" mask="0\9\9\99 99 99 99" className="msisdn-mask" inputMode="numeric" autoComplete="off" />
									</div>
								</Form.Item>
								<Form.Item>
									<Button className="btn-normal btn-green" type="default" htmlType="submit">
										نمایش بسته‌ها
									</Button>
								</Form.Item>
							</Form>
						</section>
					)}
					{pack?.isPackages && (
						<>
							<ShopSummary
								wide
								msisdn={pack.msisdn}
								empty={selected ? null : "یک بسته انتخاب کنید"}
								rows={[
									["بسته", selected?.packageName],
									["قابل دریافت از مشتری", toman(total)],
									["سود شما از فروش", toman(commission)],
								]}
								total={["برداشت از کیف پول", toman(walletDebit)]}
								action={
									selected && (
										<Button className="sum-action" size="large" onClick={goPrefactor}>
											ادامه و پیش فاکتور
										</Button>
									)
								}
							/>
							<section className="shop-section">
								<h4>
									<span className="num">{pack?.purchase ? "۱" : "۲"}</span>
									انتخاب بسته
								</h4>
								<Packages
									categoryList={pack?.cagegoryList}
									packagesList={pack?.packageList}
									selected={selected}
									onSelect={setSelected}
									onContinue={goPrefactor}
								/>
							</section>
						</>
					)}
				</div>
			</ShopPage>
			<Loading isOpen={pack?.isLoading} />
		</>
	);
};

export default EPValid;
